import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-fame-hall',
  templateUrl: './fame-hall.component.html',
  styleUrls: ['./fame-hall.component.css']
})
export class FameHallComponent implements OnInit {

  ArjunAwards: any;
  DronaAwards: any;
  DhyanChand: any;
  PadmaShree: any;
  awardsData:any

  constructor(  private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService) { 

this.awardsData=[
  {name:'Arjuna Award'},
  {name:'Arjuna Award'},
  {name:'Arjuna Award'},
  {name:'Arjuna Award'},

]

    }
    

  ngOnInit(): void {
    this.getAwardsArjun();
    this.getAwardsDrona();
    this.getAwardsDhyan();
    this.getAwardsPadma();
  }




  getAwardsArjun() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=awardee&awardName=Arjuna Award";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.ArjunAwards = data.reverse();
    });
  }
  getAwardsDrona() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=awardee&awardName=Dronacharya Award";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.DronaAwards = data.reverse();
    });
  }
  getAwardsDhyan() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=awardee&awardName=Dhyan Chand Award";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.DhyanChand = data.reverse();
    });
  }
  getAwardsPadma() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=awardee&awardName=Padmashree Award";
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.PadmaShree = data.reverse();
    });
  }

}
